<template>
  <a-modal
    :visible="visible"
    centered
    @cancel="handleCancel"
    width="70%"
    :footer="false"
  >
    <template slot="title">
      <div class="text-center">
        <h4 class="mb-0">{{ $t("bulletin.duplicateSettings") }}</h4>
      </div>
    </template>

    <div class="p-3">
      <!-- Source -->
      <div class="mb-4">
        <a-divider orientation="left">{{ $t("bulletin.source") }}</a-divider>
        <div class="row">
          <div class="col-md-4">
            <label class="form-label">{{ $t("etablissement.type") }}</label>
            <a-select
              class="w-100"
              :value="sourceType"
              @change="sourceType = $event"
            >
              <a-select-option
                v-for="(value, key) in bulletinTypesNames"
                :key="key"
                :value="key"
              >
                {{ value }}
              </a-select-option>
            </a-select>
          </div>
          <div class="col-md-3">
            <label class="form-label">{{ $t("etablissement.niveau") }}</label>
            <a-select
              class="w-100"
              :value="sourceLevel"
              @change="sourceLevel = $event"
            >
              <a-select-option
                v-for="(value, name) in levels"
                :key="name"
                :value="name"
              >
                {{ value }}
              </a-select-option>
            </a-select>
          </div>
          <div class="col-md-5">
            <label class="form-label">{{ $t("bulletin.schoolYear") }}</label>
            <a-select
              class="w-100"
              :value="sourceSchoolarYear"
              @change="sourceSchoolarYear = $event"
              :placeholder="$t('bulletin.selectSchoolYear')"
            >
              <a-select-option
                v-for="schoolYear in schoolYears"
                :key="schoolYear._id"
                :value="schoolYear._id"
              >
                {{ schoolYear.label }}
              </a-select-option>
            </a-select>
          </div>
        </div>
      </div>

      <!-- Target -->
      <div class="mb-4">
        <a-divider orientation="left">{{ $t("bulletin.targets") }}</a-divider>
        <div class="row">
          <div class="col-md-2">
            <a-button type="primary" class="w-100 mt-4" @click="selectAll">
              {{ $t("sms.selectAll") }}
            </a-button>
          </div>
          <div class="col-md-3">
            <label class="form-label">{{ $t("etablissement.type") }}</label>
            <a-select
              class="w-100"
              mode="multiple"
              allow-clear
              :value="targetTypes"
              @change="targetTypes = $event"
              :placeholder="$t('bulletin.selectTypes')"
            >
              <a-select-option
                v-for="(value, key) in bulletinTypesNames"
                :key="key"
                :value="key"
              >
                {{ value }}
              </a-select-option>
            </a-select>
          </div>
          <div class="col-md-3">
            <label class="form-label">{{ $t("etablissement.niveau") }}</label>
            <a-select
              class="w-100"
              mode="multiple"
              allow-clear
              :value="targetLevels"
              @change="targetLevels = $event"
              :placeholder="$t('bulletin.selectLevels')"
            >
              <a-select-option
                v-for="(value, name) in levels"
                :key="name"
                :value="name"
              >
                {{ value }}
              </a-select-option>
            </a-select>
          </div>
          <div class="col-md-4">
            <label class="form-label">{{ $t("bulletin.schoolYear") }}</label>
            <a-select
              class="w-100"
              :value="targetSchoolarYear"
              @change="targetSchoolarYear = $event"
              :placeholder="$t('bulletin.selectSchoolYear')"
            >
              <a-select-option
                v-for="schoolYear in schoolYears"
                :key="schoolYear._id"
                :value="schoolYear._id"
              >
                {{ schoolYear.label }}
              </a-select-option>
            </a-select>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-4 offset-md-8">
          <a-button
            type="primary"
            class="w-100"
            @click="clone"
            :disabled="isReadOnly"
          >
            <a-icon type="save" />
            {{ $t("all.apply") }}
          </a-button>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
/*eslint-disable*/
import apiClient from "@/services/axios";
import moment from "moment";
import { mapState, mapGetters } from "vuex";

export default {
  name: "AnnualReportClone",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    levels: {
      type: Object,
      required: true,
    },
    bulletinTypesNames: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      sourceType: "",
      sourceLevel: "",
      sourceSchoolarYear: "",
      targetTypes: [],
      targetLevels: [],
      targetSchoolarYear: "",
      schoolYearsList: [],
    };
  },
  computed: {
    ...mapState(["settings"]),
    ...mapGetters("settings", ["packDetailsGetter"]),
    isReadOnly() {
      const value = this.packDetailsGetter?.access?.edManager?.displaySettings;
      return value === "ro";
    },
    schoolYears() {
      return this.schoolYearsList.map((sy) => ({
        _id: sy._id,
        label: this.formatSchoolYear(sy),
      }));
    },
  },
  watch: {
    visible: {
      handler: async function (newVal) {
        if (newVal) {
          await this.fetchSchoolYears();
        }
      },
    },
  },
  methods: {
    formatSchoolYear(sy) {
      if (!sy || !sy.start || !sy.end) return "";
      const start = moment(sy.start).format("YYYY");
      const end = moment(sy.end).format("YYYY");
      return `${start}/${end}`;
    },
    async fetchSchoolYears() {
      try {
        const response = await apiClient.post("/schoolaryears/filter", {
          query: {},
        });
        this.schoolYearsList = response.data.map((elem) => ({
          ...elem,
          key: elem._id,
        }));
        if (this.schoolYearsList.length > 0) {
          const active =
            this.settings.activeSchoolarYear || this.schoolYearsList[0]._id;
          this.sourceSchoolarYear = active;
          this.targetSchoolarYear = active;
        }
      } catch (error) {
        console.error("Error fetching school years:", error);
        this.$message.error(this.$t("error.erreur"));
      }
    },
    handleCancel() {
      this.$emit("hide");
    },
    selectAll() {
      this.targetTypes = Object.keys(this.bulletinTypesNames);
      this.targetLevels = Object.keys(this.levels);
    },
    clone() {
      if (
        !this.sourceType ||
        this.sourceLevel === "" ||
        !this.sourceSchoolarYear ||
        !this.targetTypes.length ||
        !this.targetLevels.length ||
        !this.targetSchoolarYear
      ) {
        this.$message.warning(this.$t("error.erreur"));
        return;
      }
      apiClient
        .post("/bulletin/v2/annual-report-config/clone", {
          sourceType: this.sourceType,
          sourceLevel: Number(this.sourceLevel),
          sourceSchoolarYear: this.sourceSchoolarYear,
          targetTypes: this.targetTypes,
          targetLevels: this.targetLevels.map((l) => Number(l)),
          targetSchoolarYear: this.targetSchoolarYear,
        })
        .then(() => {
          this.$message.success(this.$t("bulletin.allDataDuplicatedSuccess"));
          this.resetForm();
          this.$emit("cloneHappened");
        })
        .catch((e) => {
          console.error(e);
          this.$message.error(this.$t("error.erreur"));
        });
    },
    resetForm() {
      this.sourceType = "";
      this.sourceLevel = "";
      this.targetTypes = [];
      this.targetLevels = [];
    },
  },
};
</script>
